module.exports = __webpack_public_path__ + "static/story6-bffeb0290171676bba078e11c59d5440.png";